"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _animations = require("../../animations/animations");

var getDuration = function getDuration(animationCfg, animationName) {
  return animationCfg.duration || _animations.animations[animationName].config.duration;
};

var _default = getDuration;
exports["default"] = _default;
//# sourceMappingURL=getDuration.js.map